import React, { useEffect, Fragment } from 'react';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import useAuth from '../../contexts/auth';
import { colors } from '@spaceshipapp/cambridge';
import Navbar, { NAVBAR_WIDTH } from '../../components/Navbar/NavbarDesktop';
import PublicNavbar from '../../components/PublicNavbar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [{ isAuthenticated }, { resumeSession }] = useAuth();

  useEffect(() => {
    if (window) {
      resumeSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      {!isAuthenticated && <PublicNavbar />}
      {isAuthenticated && <Navbar isAuthenticated={isAuthenticated} />}
      <Main className={isAuthenticated ? authed : main}>{children}</Main>
    </Fragment>
  );
};

const Main = styled.main`
  display: grid;
  position: relative;
  height: 100%;
  grid-template-rows: auto 1fr;
`;

const authed = css`
  padding-left: ${NAVBAR_WIDTH};
`;

const main = css`
  background-color: ${colors.brandSecondary};
`;

export default Layout;
